// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3MVek","header":"MergedInvoice_header__3wkC1"};